export const APP_NAME = 'facturacion-electronica';
